<template>
    <v-container fluid class="ma-0 pa-0">
        <progress-overlay :Loading="Loading"></progress-overlay>
        <div class="filterContainerHeader">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="expandAll" v-show="checkIfPanelCollapsed()"><v-icon>add</v-icon></v-btn>
                </template>
                <span>Expand all filters.</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="collapseAll" v-show="checkIfPanelExpanded()"><v-icon>remove</v-icon></v-btn>
                </template>
                <span>Collapse all filters.</span>
            </v-tooltip>
            <v-btn small color="black" @click="applyFilters" :dark="benchmarkFiltersApplied" :disabled="!benchmarkFiltersApplied">
                Apply Selections
            </v-btn>
        </div>
        <VuePerfectScrollbar style="height:80vh" :settings="settings">
            <v-divider></v-divider>
            <v-expansion-panels v-model="panel" multiple accordion>
                <v-expansion-panel v-for="(category,index) in Categories" :key="index">
                    <v-expansion-panel-header><span><strong>{{ category.categoryName }}</strong><br /> <span class="caption">Max Selections: {{category.maxSelection}}</span></span></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-list dense class="ma-0 pa-0">
                            <div v-if="category.maxSelection==1">
                                <v-list-tile-content class="ma-0 pa-0">
                                    <v-radio-group v-model="benchmarkFilterRadios[index]">
                                        <v-radio v-for="keyval in category.keyValues"
                                                 :key="keyval.itemName"
                                                 :label="keyval.itemName"
                                                 :value="keyval.itemValue"
                                                 color="indigo"
                                                 @change="onCheckboxChange"
                                                 class="pl-0 ma-0"></v-radio>
                                    </v-radio-group>
                                </v-list-tile-content>
                            </div>
                            <div v-else>
                                <v-list-item-group class="ma-0 pa-0">
                                    <v-list-item v-for="keyval in category.keyValues" :key="keyval.itemName" class="ma-0 pa-0">
                                        <v-checkbox :label="keyval.itemName"
                                                    color="indigo"
                                                    v-model="keyval.isSelected"
                                                    @change="onCheckboxChange"
                                                    :disabled='disabledFunc(category) && !keyval.isSelected' class="ma-0 pa-0"></v-checkbox>
                                    </v-list-item>
                                </v-list-item-group>

                            </div>
                        </v-list>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </VuePerfectScrollbar>
    </v-container>
</template>
<script>
    import { mapState } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import ProgressOverlay from '../_partial/ProgressOverlay'
    export default {
        components: {
            VuePerfectScrollbar,
            ProgressOverlay
        },
        data() {
            return {
                Loading: false,
                panel: [],
                filtersUpdated: false,
                settings: {
                    maxScrollbarLength: 60
                }
            }
        },
        created() {
            //this.$store.dispatch('CategoriesStore/getAllCategories', 'benchmark')
        },
        computed: {
            ...mapState({
                Categories: state => state.CategoriesStore.benchmarkfilterCategories,
                benchmarkFiltersApplied: state => state.CategoriesStore.benchmarkFiltersApplied,
                dataCountInfo: state => state.YourDataStore.dataCountInfo,
                chartData: state => state.YourDataStore.chartData,
                tableData: state => state.YourDataStore.tableData,
            }),
            modelBenchmarkFilters: {
                get() {
                    return this.$store.state.CategoriesStore.modelBenchmarkFilters;
                },
                //set(newVal) {
                //    this.$store.state.CategoriesStore.modelBenchmarkFilters = newVal;
                //}
            },
            benchmarkFilterRadios: {
                get() {
                    return this.$store.state.CategoriesStore.benchmarkFilterRadios;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.benchmarkFilterRadios = newVal;
                }
            },
        },
        watch: {
            //benchmarkFiltersApplied: function () {
            //   this.filtersUpdated =   !this.filtersUpdated;
            //if (this.modelBenchmarkFilters.length > 0) {
            //    this.filtersUpdated = true;
            //}
            //else {
            //    this.filtersUpdated = false;
            //}
            // }
        },
        methods: {
            disabledFunc: function (x) {
                var count = 0;
                x.keyValues.map(function (m) {
                    if (m.isSelected)
                        count = count + 1;
                });
                //if (x.maxSelection == '*')
                //    return false;
                if (count >= x.maxSelection)
                    return true;
                else
                    return false;
            },
            onCheckboxChange() {
                this.$store.state.CategoriesStore.benchmarkFiltersApplied = true;
                this.$store.state.CategoriesStore.modelBenchmarkFilters = this.Categories;
                //this.Categories.filter(function (l) {
                //    return l.categoryName
                //}).map(function (l) {
                //    var Categoryname = l.categoryName
                //    var diplay = l.displaySection
                //    var maxselection = l.Maxselection
                //    var CategoryId = l.CategoryId
                //    return l.keyValues.filter(function (l) {
                //        return l.isSelected
                //    }).map(function (l) {
                //        return {
                //            category: Categoryname,
                //            displaySection: diplay,
                //            Maxselection: maxselection,
                //            CategoryId: CategoryId,
                //            keyValues: [{
                //                itemName: l.itemName,
                //                itemValue: l.itemValue,
                //                sortOrder: l.sortOrder,
                //                isSelected: l.isSelected
                //            }]
                //        };

                //    })
                //})
            },
            applyFilters() {

                /* var selectedCategories = [];
                 for (var i = 0; i < this.Categories.length; i++) {
                     var keyvalues = this.Categories[i].keyValues;
                     var catName = this.Categories[i].categoryName;
                     var selCategory = {
                         categoryName: catName,
                         keyValues: []
                     };
                     for (var j = 0; j < keyvalues.length; j++) {
                         var keyval = this.Categories[i].keyValues[j];
                         if (keyval.isSelected) {
                             var newKeyVal = {
                                 itemName: keyval.itemName,
                                 itemValue: keyval.itemValue
                             }
                             selCategory.keyValues.push(newKeyVal);
                         }
                     }
                     if (selCategory.keyValues.length > 0) {
                         selectedCategories.push(selCategory);
                     }
                 }*/

                let selectedCategories = [];
                this.Categories.map((cat) => {
                    let selCategory = {
                        categoryName: cat.categoryName,
                        keyValues: []
                    };
                    let keyval = cat.keyValues.filter((data) => {
                        return data.isSelected == true;
                    })
                    if (keyval.length > 0) {
                        selCategory.keyValues = keyval;
                    }
                    this.benchmarkFilterRadios.map((radio) => {
                        let keyval = cat.keyValues.filter((data) => {
                            return radio == data.itemValue && data.isSelected == false;
                        })
                        if (keyval.length > 0) {
                            selCategory.keyValues = keyval;
                        }
                    })
                    if (selCategory.keyValues.length > 0) {
                        selectedCategories.push(selCategory);
                    }
                })

                this.$store.dispatch('CategoriesStore/settblBenchmarkFilters', selectedCategories);

                this.$store.state.CategoriesStore.benchmarkFiltersApplied = false;
                this.Loading = true;
                this.$store.dispatch('YourDataStore/getChartDataBOB')
                    .then(() => {
                        this.Loading = false;
                        var benchmarkData = "Benchmark";
                        var benchmarkDataArray = this.chartData.datasets.filter(function (item) {
                            return item.label.toUpperCase() == benchmarkData.toUpperCase();
                        });
                        if (benchmarkDataArray != null && benchmarkDataArray.length > 0) {

                            var dataArray = benchmarkDataArray[0].data.filter(function (item) {
                                return item != 0;
                            });
                            if (dataArray != null && dataArray.length > 0) {
                                return;
                            }
                            else {
                                this.$store.dispatch('AppStore/SetAlert', { alert: "Not enough data to display a benchmark. Please modify your selections.", isError: true })
                            }
                        }
                        //if (this.dataCountInfo.benchmarkDataCount <= 400) {
                        //    this.$store.dispatch('AppStore/SetAlert', { alert: "Not enough data to display a benchmark. Please modify your selections.", isError: true })
                        //}
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            expandAll() {
                this.panel = [];
                for (var i = 0; i < this.Categories.length; i++) {
                    this.panel.push(i);
                }
            },
            collapseAll() {
                this.panel = [];
            },
            checkIfPanelCollapsed() {
                var result = true;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == true) {
                        result = false;
                    }
                }
                return result;
            },
            checkIfPanelExpanded() {
                var result = false;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == true) {
                        return true;
                    }
                }
                return result;
            }
        }
    };
</script>
<style lang="scss">
    .scroll-area {
        /*        position: absolute;
        margin: auto;*/
        position: relative;
        margin: auto;
        width: 400px;
        height: 300px;
    }

    .drawer-menu--scroll {
        height: calc(100vh - 48px);
        overflow: auto
    }
</style>
